import {
  EESDPChangesActions,
  ESDPChangesActions,
} from '@myStore/ESDP-changes/ESDP-changes.actions';
import {
  IESDPChangesState,
  initialESDPChangesState,
} from '@myStore/ESDP-changes/ESDP-changes.state';

export const ESDPChangesReducers = (
  state = initialESDPChangesState,
  actions: ESDPChangesActions
): IESDPChangesState => {
  switch (actions.type) {
    case EESDPChangesActions.CreateESDPTeamsRequest:
      return { ...state, isLoading: true };
    case EESDPChangesActions.CreateESDPTeamsSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.CreateESDPTeamsFailure:
      return {
        ...state,
        isLoading: false,
        createTeamsErrors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearCreateESDPTeams:
      return {
        ...state,
        isLoading: false,
        createTeamsErrors: [],
        success: false,
      };

    case EESDPChangesActions.CreateESDPTeamIterationRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.CreateESDPTeamIterationSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.CreateESDPTeamIterationFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearCreateESDPTeamIteration:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.DeleteTeamIterationRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.DeleteTeamIterationSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.DeleteTeamIterationFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearDeleteTeamIteration:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateIterationTimeRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateIterationTimeSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateIterationTimeFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateIterationTimeErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateRolesIterationRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateRolesIterationSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateRolesIterationFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateRolesIterationErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.DeleteStudentFromTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.DeleteStudentFromTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.DeleteStudentFromTeamFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearDeleteStudentFromTeamErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.AddStudentsToTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.AddStudentsToTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.AddStudentsToTeamFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearAddStudentsToTeamErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.TransferStudentsToTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.TransferStudentsToTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.TransferStudentsToTeamFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearTransferStudentsToTeamErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.ReturnStudentsToTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.ReturnStudentsToTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.ReturnStudentsToTeamFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearReturnStudentsToTeamErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.ChangeTeamMentorRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.ChangeTeamMentorSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.ChangeTeamMentorFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearChangeTeamMentorErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.AddTeamDocumentsRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.AddTeamDocumentsSuccess:
      return { ...state, isLoading: false, errors: null, success: true };
    case EESDPChangesActions.AddTeamDocumentsFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearAddTeamDocumentsErrors:
      return { ...state, isLoading: false, errors: null, success: false };

    case EESDPChangesActions.UpdateTeamDocumentRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateTeamDocumentSuccess:
      return { ...state, isLoading: false, errors: null, success: true };
    case EESDPChangesActions.UpdateTeamDocumentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateTeamDocumentErrors:
      return { ...state, isLoading: false, errors: null, success: false };

    case EESDPChangesActions.DeleteTeamDocumentRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.DeleteTeamDocumentSuccess:
      return { ...state, isLoading: false, errors: null, success: true };
    case EESDPChangesActions.DeleteTeamDocumentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.FreeTimeFormRemindLaterRequest:
      return { ...state, isLoading: true };
    case EESDPChangesActions.FreeTimeFormRemindLaterSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.FreeTimeFormRemindLaterFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearFreeTimeFormRemindLater:
      return {
        ...state,
        isLoading: false,
        createTeamsErrors: [],
        success: false,
      };
    case EESDPChangesActions.SendFreeTimeGraphRequest:
      return { ...state, isLoading: true };
    case EESDPChangesActions.SendFreeTimeGraphSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.SendFreeTimeGraphFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearSendFreeTimeGraph:
      return {
        ...state,
        isLoading: false,
        createTeamsErrors: [],
        success: false,
      };
    case EESDPChangesActions.ClearDeleteTeamDocumentErrors:
      return { ...state, isLoading: false, errors: null, success: false };

    case EESDPChangesActions.ActivateESDPReqeust:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.ActivateESDPSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.ActivateESDPFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearActivateESDPErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateIterationReviewRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateIterationReviewSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateIterationReviewFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateIterationReview:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateIterationCaptainReportRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateIterationCaptainReportSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateIterationCaptainReportFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateIterationCaptainReport:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateIterationStatusRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateIterationStatusSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateIterationStatusFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateIterationStatus:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.OpenAccessReviewsRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.OpenAccessReviewsSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.OpenAccessReviewsFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearOpenAccessReviews:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.AddHolidaysToTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.AddHolidaysToTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.AddHolidaysToTeamFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearAddHolidaysToTeamErrors:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.UpdateTeamRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.UpdateTeamSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.UpdateTeamFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    case EESDPChangesActions.ClearUpdateTeam:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    default:
      return state;

    case EESDPChangesActions.AddEsdpMaterialRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.AddEsdpMaterialSuccess:
      return { ...state, isLoading: false, errors: null, success: true };
    case EESDPChangesActions.AddEsdpMaterialFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearAddEsdpMaterial:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.DeleteTeamMaterialRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.DeleteTeamMaterialSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.DeleteTeamMaterialFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearDeleteTeamMaterial:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.ChangeRoleToStudentRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.ChangeRoleToStudentSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.ChangeRoleToStudentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearChangeRoleToStudent:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };

    case EESDPChangesActions.DeleteRoleToStudentRequest:
      return { ...state, isLoading: true, errors: null, success: false };
    case EESDPChangesActions.DeleteRoleToStudentSuccess:
      return { ...state, isLoading: false, success: true };
    case EESDPChangesActions.DeleteRoleToStudentFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.errors,
        success: false,
      };
    case EESDPChangesActions.ClearDeleteRoleToStudent:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };
  }
};
